module.exports = __webpack_public_path__ + "static/liva-case-study-a9861b12e240a1570f985076a39e784c.webp";